import SEOSnippetSeo from './SEOSnippetSeo';

export default SEOSnippetSeo;
